let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ced9G")).then(() => parcelRequire('fivEJ'));